module.exports = __webpack_public_path__ + "img/and.af029b80.png";